import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { showConfirm } from 'components/modal/showConfirm';
import { cancelPayment } from 'libs/api/learning';
import { useTimezone } from 'libs/hooks';
import { showNotification, numberToKorean } from 'libs/utils';
import {
  EMentoringTicketBackendNaming,
  CMentoringTicketOriginNumber,
  CMentoringTicketRefundKeyname,
  CSeniorTicketOriginNum,
  CJuniorTicketOriginNum,
  EFinanceMentoringTicketBackendNaming,
} from 'modules/mentoring';
import { TModalProps } from 'modules/types';
import { TUser, setUserInfo } from 'modules/user';
import { Modal, Button, Row } from 'antd';
import styled from 'styled-components';
import { Colors, SecondaryColor } from 'GlobalStyles';

const RefundRequestModal = ({ modalState, setModalState }: TModalProps) => {
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [getDateTime, timezone] = useTimezone();
  const [refundAmount, setRefundAmount] = useState<number>();
  const dispatch = useDispatch();

  function handleCancel() {
    setModalState({ visible: false });
    // form.resetFields();
  }

  function handleSubmit() {
    handleCancelPayment();

    async function handleCancelPayment() {
      if (refundAmount && refundAmount > 0) {
        try {
          setSubmitButtonDisabled(true);
          const { data } = await cancelPayment({
            merchant_uid: get(modalState.record, 'merchant_uid'),
            cancel_request_amount: refundAmount,
            reason: '단순변심', //하드코딩
          });
          if (data.status === 'success') {
            showNotification('success', '구매가 취소되었습니다');
            console.log('🌸data.user as TUser', data.user);

            dispatch(setUserInfo(data.user as TUser));
            // changeUserInfo();
          }

          handleCancel();
        } catch (e) {
          throw e;
        } finally {
          setSubmitButtonDisabled(false);
        }
      }
    }
  }

  //남아있는 수강권 개수 계산
  const calculateRemainTicket = (ticketName: string): number => {
    let remainTicketNum;
    //MockInterviewPackage일 때는 시니어 남은 수량 + 주니어 남은 수량 더해줘야한다
    if (ticketName === EMentoringTicketBackendNaming.MockInterviewPackage) {
      remainTicketNum =
        get(modalState.record, 'ticket_balance').junior_ticket +
        get(modalState.record, 'ticket_balance').senior_ticket;
    } else {
      remainTicketNum = get(modalState.record, 'ticket_balance');
    }
    return remainTicketNum;
  };

  //남아있는, 사용한 수강권 개수 활용하여 환불 금액 계산
  const calculateRefundAmount = (ticketName: string, cancelAmount: any) => {
    let refundTotalAmount;
    //cancelAmount가 null 이 아니면 멘토링 수강권이라는것
    if (cancelAmount) {
      if (
        ticketName === EMentoringTicketBackendNaming.RegularPackage ||
        ticketName === EMentoringTicketBackendNaming.TutorialPackage ||
        ticketName === EMentoringTicketBackendNaming.MockInterviewSenior ||
        ticketName === EMentoringTicketBackendNaming.MockInterviewJunior ||
        ticketName === EFinanceMentoringTicketBackendNaming['60Minutes']
      ) {
        refundTotalAmount =
          calculateRemainTicket(ticketName) *
          Number(get(cancelAmount, CMentoringTicketRefundKeyname[ticketName]));

        return refundTotalAmount;
      } else if (ticketName === EMentoringTicketBackendNaming.MockInterviewPackage) {
        //시니어, 주니어 환불가격 따로 계산해줘야하는 특수 상황 ==> 하나도 안썼을 때는 150만원 환불 / 쓴만큼 깎아서 0원 밑으로 내려갈 때는 0원 환불
        if (Number(calculateRemainTicket(ticketName)) === 5) {
          //하나도 안썼으면 낸 돈(150만원) 그대로 환불
          refundTotalAmount = Number(get(modalState.record, 'amount'));
          return refundTotalAmount;
        } else {
          //하나라도 썼으면 낸 돈(150만원) 에서 쓴만큼 빼서 환불 (만약 마이너스 값이면 0원으로 표시)
          refundTotalAmount =
            Number(get(modalState.record, 'amount')) -
            ((CJuniorTicketOriginNum - get(modalState.record, 'ticket_balance').junior_ticket) *
              Number(get(cancelAmount, 'junior_ticket')) +
              (CSeniorTicketOriginNum - get(modalState.record, 'ticket_balance').senior_ticket) *
                Number(get(cancelAmount, 'senior_ticket')));
          if (refundTotalAmount <= 0) {
            return 0;
          } else {
            return refundTotalAmount;
          }
        }
      }
    } else {
      // cancelAmount가 null이면 케이스 노트 혹은 케이스 문제
      //케이스 노트/케이스 문제/엑셀 영상강의 일 경우 모달이 열린다는 것은 전액 환불 가능한 것
      refundTotalAmount = Number(get(modalState.record, 'amount'));
      return refundTotalAmount;
    }
  };

  useEffect(() => {
    if (modalState.visible) {
      const refund = calculateRefundAmount(
        get(modalState.record, 'product_name'),
        get(modalState.record, 'ticket_cancel_amount'),
      );
      setRefundAmount(refund);
    }
  }, [modalState]);

  return (
    <StyledModalWrapper>
      <Modal
        visible={modalState.visible}
        // visible={true}
        maskClosable={true}
        onCancel={handleCancel}
        width={600}
        centered={true}
        title={
          <div style={{ marginTop: '20px' }}>
            <h1
              style={{
                fontWeight: 'bolder',
              }}
            >
              구매 취소
            </h1>
            <div style={{ fontSize: '0.9rem', fontWeight: 'bolder' }}>
              구매일시 : {getDateTime(get(modalState.record, 'created_at')).format('YY년 MM월 DD일 HH:mm:ss')}
            </div>
          </div>
        }
        footer={
          <Row justify='space-between'>
            <Button className='long' onClick={handleCancel}>
              닫기
            </Button>
            <Button
              className='secondary long'
              onClick={() => showConfirm(() => handleSubmit(), '정말 구매를 취소하시겠습니까?')}
              loading={submitButtonDisabled}
            >
              구매 취소
            </Button>
          </Row>
        }
      >
        <StyledModalBody>
          <StyledPurchaseInfo>
            <StyledContentTitle>구매 정보</StyledContentTitle>
            {/* 수강권을 한번도 사용하지 않은 경우(0일경우)에는 '수강권 사용 횟수'와 '남은 수강권'이 나오지 않고 구매한 수강권과 그 갯수만 나오도록 */}
            {Number(
              CMentoringTicketOriginNumber[get(modalState.record, 'product_name')] -
                calculateRemainTicket(get(modalState.record, 'product_name')),
            ) > 0 ? (
              <StyledContents>
                {/* 사용한 수강권이 0개 초과  */}
                <div className='content'>
                  <span>{get(modalState.record, 'product_name')}</span>
                  <span>{CMentoringTicketOriginNumber[get(modalState.record, 'product_name')] || '-'}회</span>
                </div>
                <div className='content'>
                  <span>수강권 사용 횟수</span>
                  <span>
                    {CMentoringTicketOriginNumber[get(modalState.record, 'product_name')] -
                      calculateRemainTicket(get(modalState.record, 'product_name'))}
                    회
                  </span>
                </div>
                <div className='content' style={{ color: SecondaryColor, marginTop: '10px' }}>
                  <span>남은 수강권</span>
                  <span>{calculateRemainTicket(get(modalState.record, 'product_name'))}회</span>
                </div>
              </StyledContents>
            ) : (
              <StyledContents>
                {/* (사용한 수강권 0개 일경우) */}
                <div className='content'>
                  {/* 멘토링 관련 티켓은 기존에 정해진 횟수를 보여주고 케이스 노트 or 케이그 문제 이용권은 아무것도 보여주지 않도록 */}
                  <span>{get(modalState.record, 'product_name')}</span>
                  {/* 케이스 노트, 케이스 문제, 엑셀 영상 강의는 CMentoringTicketOriginNumber 자체가 없으므로 아래는 뜨지 않는다  */}
                  {CMentoringTicketOriginNumber[get(modalState.record, 'product_name')] && (
                    <span>
                      {CMentoringTicketOriginNumber[get(modalState.record, 'product_name')] || '-'}회
                    </span>
                  )}
                </div>
              </StyledContents>
            )}
          </StyledPurchaseInfo>
          <StyledPurchaseInfo style={{ marginTop: '52px' }}>
            <StyledContentTitle>환불정보</StyledContentTitle>
            <StyledContents>
              <div className='content'>
                <span>{get(modalState.record, 'pay_method') === 'card' ? '신용카드' : ''} 결제</span>
                <span>
                  {' '}
                  {/* {String(get(modalState.record, 'amount'))
                    .replace('.00', '')
                    .replace('0000', '만')} */}
                  {String(
                    numberToKorean(Number(String(get(modalState.record, 'amount')).replace('.00', ''))),
                  ).replace(',000', '천')}
                  원
                </span>
              </div>
              <div className='content' style={{ color: SecondaryColor }}>
                <span>총 환불 금액</span>
                <span>
                  {String(numberToKorean(Number(String(refundAmount).replace('.00', '')))).replace(
                    ',000',
                    '천',
                  )}
                  원
                </span>
              </div>
            </StyledContents>
          </StyledPurchaseInfo>
          <StyledRefundNotification>
            <div>&bull; 할인상품 차감 후 구매 취소 시 할인가가 포함되지 않습니다.</div>
            <div>
              &bull; 실전 Mock 인터뷰 패키지 구매 후 사용 시 남은 수강권 종류에 따라 환불금액이 정산됩니다.
            </div>
          </StyledRefundNotification>
        </StyledModalBody>
      </Modal>
    </StyledModalWrapper>
  );
};

export default RefundRequestModal;

const StyledModalWrapper = styled.div``;

const StyledModalBody = styled.div`
  margin: 10px 20px 52px 20px;
`;

const StyledPurchaseInfo = styled.div``;

const StyledContentTitle = styled.h2`
  font-weight: 900;
`;

const StyledContents = styled.div`
  padding: 15px 5px;
  border-top: 2px solid black;
  border-bottom: 2px solid ${Colors.grey1};
  & .content {
    display: flex;
    justify-content: space-between;
  }
`;

const StyledRefundNotification = styled.div`
  margin-top: 52px;
`;
